package one.healthium.log_symptoms.di

import one.healthium.health_advice.data.AppHealthAdviceRepository
import one.healthium.health_advice.domain.HealthAdviceInteractor
import one.healthium.health_advice.domain.HealthAdviceRepository
import one.healthium.health_advice.ui.message.HealthAdviceMessageViewModel
import one.healthium.health_log.ui.HealthLogViewModel
import one.healthium.log_symptoms.ui.LogSymptomsViewModel
import org.koin.core.module.dsl.factoryOf
import org.koin.core.module.dsl.singleOf
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.bind
import org.koin.dsl.module

val logSymptomsUiModule = module {
    singleOf(::AppHealthAdviceRepository) bind HealthAdviceRepository::class

    factoryOf(::HealthAdviceInteractor)

    viewModelOf(::LogSymptomsViewModel)
    viewModelOf(::HealthLogViewModel)
    viewModelOf(::HealthAdviceMessageViewModel)
}